interface PropertyTypeIconProps {
  stroke?: string;
}

const PropertyTypeIcon = ({ stroke }: PropertyTypeIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M7.25 16.25V10.7C7.25 10.28 7.25 10.0699 7.33175 9.90951C7.40365 9.76839 7.51839 9.65365 7.65951 9.58175C7.81994 9.5 8.02996 9.5 8.45 9.5H10.55C10.97 9.5 11.1801 9.5 11.3405 9.58175C11.4816 9.65365 11.5964 9.76839 11.6683 9.90951C11.75 10.0699 11.75 10.28 11.75 10.7V16.25M2 7.625L8.78 2.54C9.0382 2.34635 9.16729 2.24953 9.30908 2.21221C9.43423 2.17926 9.56578 2.17926 9.69093 2.21221C9.83271 2.24953 9.96181 2.34635 10.22 2.54L17 7.625M3.5 6.5V13.85C3.5 14.6901 3.5 15.1101 3.66349 15.431C3.8073 15.7132 4.03677 15.9427 4.31902 16.0865C4.63988 16.25 5.05992 16.25 5.9 16.25H13.1C13.9401 16.25 14.3601 16.25 14.681 16.0865C14.9632 15.9427 15.1927 15.7132 15.3365 15.431C15.5 15.1101 15.5 14.6901 15.5 13.85V6.5L10.94 3.08C10.4236 2.69271 10.1654 2.49906 9.88185 2.42442C9.63155 2.35853 9.36846 2.35853 9.11815 2.42442C8.83459 2.49906 8.57639 2.69271 8.06 3.08L3.5 6.5Z"
        stroke={stroke ?? '#9BA3AE'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PropertyTypeIcon;
